const ONE_DAY_MS = 24 * 60 * 60 * 1000;
var TargetDateType = /*#__PURE__*/function (TargetDateType) {
  TargetDateType[TargetDateType["DAY"] = 0] = "DAY";
  TargetDateType[TargetDateType["WEEK"] = 1] = "WEEK";
  TargetDateType[TargetDateType["MONTH"] = 2] = "MONTH";
  TargetDateType[TargetDateType["YEAR"] = 3] = "YEAR";
  return TargetDateType;
}(TargetDateType || {});
export function convertUsecToDate(usec) {
  const ms = usec / 1000;
  return new Date(ms);
}
export function getStartOfDay(originalDate) {
  const date = new Date(originalDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
export function addDays(date, amount) {
  return add(date, amount, TargetDateType.DAY);
}
export function addWeeks(date, amount) {
  return add(date, amount, TargetDateType.WEEK);
}
export function addMonths(date, amount) {
  return add(date, amount, TargetDateType.MONTH);
}
export function addYears(date, amount) {
  return add(date, amount, TargetDateType.YEAR);
}
export function subtractWeeks(date, amount) {
  return subtract(date, amount, TargetDateType.WEEK);
}
export function subtractMonths(date, amount) {
  return subtract(date, amount, TargetDateType.MONTH);
}
export function subtractYears(date, amount) {
  return subtract(date, amount, TargetDateType.YEAR);
}
// Constructs a new date by adding the given delta to a date
function add(date, amount, Target) {
  switch (Target) {
    case TargetDateType.DAY:
      return new Date(date.getTime() + ONE_DAY_MS * amount);
    case TargetDateType.WEEK:
      return new Date(date.setDate(date.getDate() + amount * 7));
    case TargetDateType.MONTH:
      return new Date(date.setMonth(date.getMonth() + amount));
    case TargetDateType.YEAR:
      return new Date(date.setFullYear(date.getFullYear() + amount));
  }
}

// Constructs a new date by subtracting the given delta from a date
function subtract(date, amount, Target) {
  switch (Target) {
    case TargetDateType.DAY:
      return new Date(date.getTime() - ONE_DAY_MS * amount);
    case TargetDateType.WEEK:
      return new Date(date.setDate(date.getDate() - amount * 7));
    case TargetDateType.MONTH:
      return new Date(date.setMonth(date.getMonth() - amount));
    case TargetDateType.YEAR:
      return new Date(date.setFullYear(date.getFullYear() - amount));
  }
}
export function addBusinessDate(date, amount) {
  const [SUNDAY, SATURDAY] = [0, 6];
  let daysRemaining = amount;
  let newDate = getStartOfDay(date);
  while (daysRemaining > 0) {
    newDate = add(newDate, 1, TargetDateType.DAY);
    if (newDate.getDay() !== SUNDAY && newDate.getDay() !== SATURDAY) {
      daysRemaining--;
    }
  }
  return newDate;
}